import { ReactNode } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { SolidCard } from "@utilifeed/components";
import { useBrandingContext } from "@core";

export type TableColumn = {
  label: string;
  width: string;
};

export type InsightTableCardProps = Readonly<{
  title: string;
  icon: IconDefinition;
  testId: string;
  bannerColor: string;
  columns: TableColumn[];
  children: ReactNode;
}>;

export function InsightTableCard({
  title,
  icon,
  testId,
  bannerColor,
  columns,
  children,
}: InsightTableCardProps) {
  const theme = useTheme();
  const { branding } = useBrandingContext();

  return (
    <SolidCard title={title} icon={icon} testId={testId}>
      <Box
        sx={{
          backgroundColor: bannerColor,
          height: "2.286rem",
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
      />
      <TableContainer sx={{ backgroundColor: theme.palette.background.default }}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  width={column.width}
                  sx={{ borderBottomColor: branding.colors.divider2 }}
                >
                  <Typography variant="labelLarge" color="text.primary">
                    {column.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableCell-root": {
                color: theme.palette.text.primary,
                borderBottomColor: branding.colors.divider2,
              },
            }}
          >
            {children}
          </TableBody>
        </Table>
      </TableContainer>
    </SolidCard>
  );
}
